import { Formik, FormikProps } from "formik";
import { withFormikDevtools } from "formik-devtools-extension";

import { getToday } from "../../utils/dateFormatter";
import CreateCallForm, { CreateCallFormProps } from "./CreateCallForm";
import createCallFormSchema from "./createCallFormValidations";
import { CreateCallFormValues } from "./types";

const CreateCallFormWrapper = ({
  accountId,
  accountData,
  setAccountId,
}: CreateCallFormProps) => {
  const formikConfig: any = {
    onSubmit: (values: CreateCallFormValues) => {},
    initialValues: createCallFormSchema.cast({
      issueDate: getToday(),
    }) as CreateCallFormValues,
    validationSchema: createCallFormSchema,
    validateOnMount: true,
  };

  return (
    <Formik {...formikConfig}>
      {(formikProps: FormikProps<CreateCallFormValues>) => {
        withFormikDevtools(formikProps);
        return (
          <CreateCallForm
            accountId={accountId}
            accountData={accountData}
            setAccountId={setAccountId}
          />
        );
      }}
    </Formik>
  );
};

export default CreateCallFormWrapper;
